<template>
  <div>
    <SysDialog v-model="dialog_ativo" @click:primary="salvar">
      <template #ativador>
        <slot name="ativador" :callback="abrirDialog"/>
      </template>

      <template #titulo.texto>
        <div>
          <p class="ma-0">Fracionamento de Pedido</p>
          <p class="ma-0 mt-n2 font-12 font-weight-regular text-gray-1000">
            O sistema gerará múltiplos pedidos, conforme a configuração abaixo
          </p>
        </div>
      </template>

      <div>
        <TextFieldFormatadorDeValor
          v-model="registro.quantidade_produtos"
          label="Quantidade máxima de produtos por pedido"
          outlined
          inteiro
        />

        <TextFieldFormatadorDeValor
          v-model="registro.peso"
          label="Peso máximo por pedido"
          outlined
        />

        <TextFieldFormatadorDeValor
          v-model="registro.cubagem"
          label="Cubagem máxima por pedido"
          outlined
        />

        <v-checkbox
          v-model="registro.drp_fracionamento_pedidos_por_filiais_origem_destino_unicos"
          label="Criação de pedido por cada filial origem-destino diferente"
        />

        <v-checkbox
          v-model="registro.fracionar_pedidos_existentes"
          label="Fracionar pedidos existentes"
        />
      </div>
    </SysDialog>

    <DialogAlertaProdutosFracionamento
      v-model="dialog_alerta_produto_ativo"
      :produtos="produtos_alerta"
      :limite-exibicao="3"
    />
  </div>
</template>

<script setup>
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import api from "@/api/api";

import { ref } from "vue";
import { logout } from "@/helpers";
import DialogAlertaProdutosFracionamento
  from "@/components/drp/separacaoDeMercadorias/Carrinho/ListaOpcoes/DialogAlertaProdutosFracionamento.vue";

const dialog_ativo = ref(false);
const dialog_alerta_produto_ativo = ref(false);
const produtos_alerta = ref([]);

const registro = ref({
  quantidade_produtos: '',
  peso: '',
  cubagem: '',
  drp_fracionamento_pedidos_por_filiais_origem_destino_unicos: false,
  fracionar_pedidos_existentes: true,
});

function abrirDialog() {
  dialog_ativo.value = true;
  buscar()
}

function buscar() {
  api.get('pedidos-drp/fracionamentos')
    .then(response => {
      registro.value.quantidade_produtos = response.data.fracionamento.quantidade_produtos;
      registro.value.peso = response.data.fracionamento.peso;
      registro.value.drp_fracionamento_pedidos_por_filiais_origem_destino_unicos = response.data.fracionamento.drp_fracionamento_pedidos_por_filiais_origem_destino_unicos;
      registro.value.cubagem = response.data.fracionamento.cubagem;
    })
    .catch(logout)
}

const emit = defineEmits(['atualizarFracionamento'])

function salvar() {
  api.post('pedidos-drp/fracionamentos', { ...registro.value })
    .then((response) => {
      dialog_ativo.value = false;
      produtos_alerta.value = response.data.produtos_alerta;

      if (produtos_alerta.value.length > 0) {
        dialog_alerta_produto_ativo.value = true; 
      }

      emit('atualizarFracionamento', true);
    })
    .catch(logout)
}
</script>
